import { OrdersModel } from '@pukka/api';
import { numberUtils } from '@pukka/common/utils';
import { Text } from '@pukka/ui-components';

import { isRefundingTheLastItem, RefundItems } from './refundUtils';

interface TransactionRefundModalProps {
  readonly refundItems: RefundItems;
  readonly transactionDetail: OrdersModel.OrderDetail;
}

function RefundRounding({ refundItems, transactionDetail }: TransactionRefundModalProps) {
  const renderRounding =
    isRefundingTheLastItem(refundItems, transactionDetail.refund_availability) &&
    Boolean(parseInt(transactionDetail.total_rounding_amount as unknown as string, 10));

  return renderRounding ? (
    <div className="mb-4 flex justify-between border-t py-2">
      <Text weight="semibold">Rounding</Text>
      <Text>
        {Number.isFinite(transactionDetail.total_rounding_amount) &&
          numberUtils.formatCurrency(transactionDetail.total_rounding_amount, 'Rp.')}
      </Text>
    </div>
  ) : null;
}

export { RefundRounding };
